// extracted by mini-css-extract-plugin
export default {"mainCover":"insights-cover_mainCover__rb5b+","cover_section":"insights-cover_cover_section__r74Wf","coverImg":"insights-cover_coverImg__wipaE"};